<h3>Popular Contacts</h3>
<mat-card class="card" *ngFor="let contact of contacts">
  <mat-card-title>{{contact.name}}</mat-card-title>
  <mat-card-subtitle>{{contact.number}}</mat-card-subtitle>
</mat-card>
